
import {Component, Mixins, Prop, Ref} from "vue-property-decorator";
import SimpleInputMixin from "@/mixins/SimpleInputMixin.vue";
import FormWrapper from "@/components/FormWrapper.vue";
import TarafSifatiPicker from "@/components/pickers/TarafSifatiPicker.vue";
import TcKimlikNumarasi from "@/components/inputs/TcKimlikNumarasi.vue";
import {KisiSorgulamaCevap} from "@/plugins/uyap-plugin/uyap/KisiSorgulama";
import TakipRolleri, {TakipRol} from "@/plugins/uyap-plugin/takip_ac/parser/TakipRolleri";
import PostaKodu from "@/components/inputs/PostaKodu.vue";
import AdresTuruPicker from "@/components/pickers/AdresTuruPicker.vue";
import {MDB} from "@/plugins/uyap-plugin/MDB";
import MersisNumarasi from "@/components/inputs/MersisNumarasi.vue";
import VergiNumarasi from "@/components/inputs/VergiNumarasi.vue";
import DetsisNumarasi from "@/components/inputs/DetsisNumarasi.vue";
import {KurumSorgulamaCevap} from "@/plugins/uyap-plugin/uyap/KurumSorgulama";
import {GetKurumMersisAdresiCevap} from "@/plugins/uyap-plugin/uyap/GetKurumMersisAdresi";
import {VForm} from "@/types";
import KurumAdi from "@/components/inputs/KurumAdi.vue";

@Component({
  components: {
    KurumAdi,
    DetsisNumarasi,
    VergiNumarasi,
    MersisNumarasi, AdresTuruPicker, PostaKodu, TcKimlikNumarasi, TarafSifatiPicker, FormWrapper
  }
})
export default class UcuncuTarafForm extends Mixins(SimpleInputMixin) {
  @Ref('form') readonly form!: VForm;
  @Prop() dosyaId!: string;
  @Prop() maasHaczi!: string | boolean;
  @Prop() varsayilan!: string | boolean;

  valid = false;
  loading = false;
  selectedAdres: Array<any> = [];
  adresler: Array<any> = [];
  adresErr = false;
  headers = [
    {text: 'Adres Türü', value: 'adresTuruAciklama'},
    {text: 'İl/İlçe', value: 'ilIlce'},
    {text: 'Adres', value: 'adres'},
    {text: 'Posta Kodu', value: 'postaKodu'}
  ]
  roles: Array<TakipRol> = [];
  tempAdres: Adres = new Adres();
  mdb = new MDB();
  mernisAdresiVarMi: boolean = false;
  eTebligatAdresiKullan: boolean = false;
  kisiIslemDegerleri = {
    ad: null as string|null,
    soyad: null as string|null
  }
  kurumIslemDegerleri = {
    mersisNo: null as string|null,
    vergiNo: null as number|null,
    detsisNo:null as string|null,
    kurumAd: null as string|null
  }
  illerIlceler: any = [];

  get isMaasHaczi() {
    return this.maasHaczi || this.maasHaczi === "";
  }

  get isVarsayilan() {
    return this.varsayilan || this.varsayilan === "";
  }

  async onKisiBilgileriChange(uyapData: KisiSorgulamaCevap) {
    this.localValue.temelBilgileri = uyapData;
    this.kisiIslemDegerleri.ad = uyapData.adi;
    this.kisiIslemDegerleri.soyad = uyapData.soyadi;
    this.mernisAdresiVarMi = await this.$uyap.KisiMernisAdresiVarmi().run({tcKimlikNo: uyapData.tcKimlikNo});
    this.localValue.mernisAdresiKullan = this.mernisAdresiVarMi;
    this.localValue.eTebligatAdresiKullan = this.eTebligatAdresiKullan;
    this.input();
    this.adresler = await this.$uyap.GetAdresList().run({
      kisiKurumId: uyapData.kisiKurumID,
      tarafTur: 1
    });
  }

  async onKurumBilgileriChange(uyapData: Array<KurumSorgulamaCevap>) {
    // TODO: Array geliyor
    this.localValue.temelBilgileri = uyapData[0];
    this.kurumIslemDegerleri.kurumAd = uyapData[0].kurumAdi;
    this.kurumIslemDegerleri.detsisNo = uyapData[0]?.detsisNo;
    this.kurumIslemDegerleri.mersisNo = uyapData[0].mersisNo;
    this.kurumIslemDegerleri.vergiNo = uyapData[0].vergiNo;
    let mersisData: GetKurumMersisAdresiCevap = await this.$uyap.GetKurumMersisAdresi().run({
      mersisNo: uyapData[0].mersisNo,
      vergiNo: uyapData[0].vergiNo
    });
    this.mernisAdresiVarMi = mersisData.resultCode !== 0;
    this.localValue.mernisAdresiKullan = this.mernisAdresiVarMi;
    this.localValue.eTebligatAdresiKullan = this.eTebligatAdresiKullan;
    this.input();
    this.adresler = await this.$uyap.GetAdresList().run({
      kisiKurumId: uyapData[0].kisiKurumID,
      tarafTur: 2
    });
  }

  onTarafSifatiChange() {
    delete this.localValue.tarafSifati.sanikStatusu;
    delete this.localValue.tarafSifati.davaliDavaciGrubu;
    this.input();
  }

  onAdresTuruChange(adresTuruObj: any) {
    if (adresTuruObj) {
      this.tempAdres.adresTuruAciklama = adresTuruObj.isim;
      this.tempAdres.adresTuru = adresTuruObj.uyap_kod;
    }
  }

  onIlChange(ilObj: any) {
    console.log("on il change",ilObj);
    if (ilObj) {
      this.tempAdres.ilKodu = ilObj.il;
      this.tempAdres.ilAdi = ilObj.ad;
    }
  }

  onIlceChange(ilceObj: any) {
    if (ilceObj) {
      this.tempAdres.ilceKodu = ilceObj.ilcekod;
      this.tempAdres.ilceAdi = ilceObj.ilcead;
    }
  }

  async mounted() {
    this.illerIlceler = await this.$uyap.IllerIlceler().run({});
    const takipRolleri = new TakipRolleri();
    this.roles = takipRolleri.ucuncuTarafRoller;
  }

  /**
   * E-Tebligat (KEP) adresinde UYAP il/ilçe vermiyor, adres numaralardan oluşuyor; eskiden tabloda
   * "undefined/undefined" görünüyordu (DEV-3687).
   */
  ilIlceMetni(adres: any): string {
    const parcalar = [adres?.ilAdi, adres?.ilceAdi].filter((p: any) => p);
    return parcalar.length > 0 ? parcalar.join('/') : '-';
  }

  addAdres() {
    if (this.form.validate()) {
      this.tempAdres.adresID = 'T' + (this.adresler.length + 1);
      this.adresler.push(this.tempAdres);
      this.tempAdres = new Adres();
    }
  }

 async save() {
    this.loading = true;
    if (!this.localValue.mernisAdresiKullan && this.selectedAdres.length == 0)
      this.adresErr = true;
    else {
      this.adresErr = false;
      if(this.selectedAdres.length > 0){
        console.log("selectedAdres",this.selectedAdres);
        this.localValue.adresBilgisi = {
          ilKodu: this.selectedAdres[0].ilKodu,
          ilAdi: this.selectedAdres[0].ilAdi,
          ilceKodu: this.selectedAdres[0].ilceKodu,
          ilceAdi: this.selectedAdres[0].ilceAdi,
          adres: this.selectedAdres[0].adres,
          adresTuru: this.selectedAdres[0].adresTuru,
          adresTuruAciklama: this.selectedAdres[0].adresTuruAciklama,
          postaKodu: this.selectedAdres[0].postaKodu
        }
        this.localValue.sorguTuru = 0
      }
    }
    try{
      this.localValue.tarafAdi = this.localValue.temelBilgileri.kurumAdi ? this.localValue.temelBilgileri.kurumAdi : (this.localValue.temelBilgileri.adi + " " + this.localValue.temelBilgileri.soyadi);
      if (this.isVarsayilan) {
        this.$emit("onSuccess", JSON.parse(JSON.stringify(this.localValue)));
        return;
      }
      let uyapIslemTur = this.isMaasHaczi ? 1 : 5;
      let requestData = {
        dosyaId : this.dosyaId,
        uyapIslemTur: uyapIslemTur,
        TarafList : JSON.stringify([this.localValue])
      };
      let response = await this.$uyap.DosyaTarafKaydet().run(requestData);
      this.$emit("onSuccess");
    }catch (e) {
      this.$toast.error(e.message);
    }finally {
      this.loading = false;
    }
  }
}

class Adres {
  adresID: string = "";
  ilKodu: string = "";
  ilAdi: string = "";
  ilObj: object = {};
  ilceKodu: string = "";
  ilceAdi: string = "";
  ilceObj: object = {};
  adres: string = "";
  adresTuru: string = "";
  adresTuruAciklama: string = "";
  adresTuruObj: object = {};
  postaKodu: string = "";
}
